import './AnimeChicken.css';

const overrideStyleToChicken = (tokenId) => {


    return {
        backgroundImage: `url("/images/${tokenId}.png")`
    }
};

function AnimeChicken(prop) {
    return (
        <div id="c1" >
            <div id="c2">
                <div id="c3">
                    <div id="c4">
                        <div id="c5">
                            <div id="c6">
                                <div id="c7">
                                    <div id="c8">
                                        <div id="c9">
                                            <div id="c10" style={overrideStyleToChicken(prop.tokenId)}>
                                                <div id="c11">
                                                    {prop.children}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default AnimeChicken;